{#if loadInProgress }
    <LoadingSpinner label={lang.main('Wait')} visible={true} size="large" />
{:else if totalCount > 0}
    <div class="its-course-catalogue-coursecards-list">
        {#each list as item}
            <CourseCard
                title={item.title}
                description={item.content}
                courseLink={item.courseUrl}
                courseCardImageUrl={item.imageUrl}
                targetRole={item.targetRole}
                subject={item.subject}
                teachers={item.teachers}
                educationalLevel={item.educationalLevel}
                isUserEnrolled={item.isUserEnrolled}
            />
        {/each}
    </div> 
{:else}
    <EmptyState iconName="courses" title={filterEnabled ? lang.main('Course_catalogue_no_courses_for_filter') : lang.main('No_courses')}/>
{/if}

<script  lang="ts">
    import EmptyState from "@itslearning/prometheus/assets/nodes/EmptyState/v1/EmptyState.svelte";
    import CourseCard from "../CourseCard/CourseCard.svelte";
    import LoadingSpinner from "@itslearning/prometheus/assets/nodes/LoadingSpinner/v1/LoadingSpinner.svelte";
    import { lang } from "@its-ui/mono/lang/provider";
    import type { CatalogueCourseModel } from '../../api/api.ts';

    export let filterEnabled = false;
    export let list: CatalogueCourseModel[];
    export let totalCount = 0;
    export let loadInProgress = false;
</script>
